import axios from "axios";

// La API exige DOS credenciales en cada request:
// 1) Authorization: Bearer <JWT>  -> se agrega tras el login
// 2) X-Api-Key: <clave de la app> -> fija, configurada por variable de entorno
const API_BASE_URL = process.env.REACT_APP_API_URL || "https://localhost:7001/api";
const API_KEY = process.env.REACT_APP_API_KEY || "";

const axiosClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "X-Api-Key": API_KEY,
  },
});

axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("fs_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token vencido o inválido: forzar logout
      localStorage.removeItem("fs_token");
      localStorage.removeItem("fs_user");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
